export interface HrWorkforceReadinessRule {
  readinessRuleId?: number;
  owningCompanyId?: number;
  ruleCode?: string;
  ruleName?: string;
  assignmentType?: string;
  workerCategory?: string;
  severity?: string;
  ruleConfigJson?: string;
  cacheTtlMinutes?: number;
  active?: boolean;
  systemDefault?: boolean;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrWorkforceReadinessSnapshot {
  readinessSnapshotId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  assignmentType?: string;
  assignmentResourceId?: number;
  readinessStatus?: string;
  blockerCount?: number;
  warningCount?: number;
  ruleResultsJson?: string;
  sourceModule?: string;
  sourceResourceId?: number;
  evaluatedAt?: string;
  expiresAt?: string;
  active?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrReadinessOverride {
  readinessOverrideId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  workerCategory?: string;
  assignmentType?: string;
  assignmentResourceId?: number;
  overrideStatus?: string;
  overrideReadinessStatus?: string;
  reason?: string;
  validFrom?: string;
  validUntil?: string;
  approvedByCustomerId?: number;
  createdByCustomerId?: number;
  revokedAt?: string;
  revokedByCustomerId?: number;
  revokedReason?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrDriverQualification {
  driverQualificationId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeNumber?: string;
  employeeName?: string;
  driverId?: number;
  qualificationType?: string;
  qualificationName?: string;
  qualificationStatus?: string;
  licenseNumber?: string;
  documentTypeCode?: string;
  issuingAuthority?: string;
  validFrom?: string;
  validUntil?: string;
  verifiedByCustomerId?: number;
  verifiedAt?: string;
  sourceModule?: string;
  sourceResourceId?: number;
  active?: boolean;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrWorkforceReadinessRuleResult {
  ruleCode?: string;
  ruleName?: string;
  severity?: string;
  resultStatus?: string;
  message?: string;
  blocker?: boolean;
  warning?: boolean;
}

export interface HrWorkforceReadinessEvaluationRequest {
  owningCompanyId?: number;
  employeeId?: number;
  driverId?: number;
  assignmentType?: string;
  assignmentResourceId?: number;
  assignmentStartDate?: string;
  assignmentEndDate?: string;
  requiredWorkerCategory?: string;
  sourceModule?: string;
  sourceResourceId?: number;
  forceRefresh?: boolean;
}

export interface HrWorkforceReadinessEvaluationResult {
  owningCompanyId?: number;
  assignmentType?: string;
  assignmentResourceId?: number;
  evaluatedEmployees?: number;
  readyEmployees?: number;
  warningEmployees?: number;
  blockedEmployees?: number;
  evaluatedAt?: string;
  snapshots?: HrWorkforceReadinessSnapshot[];
}

export interface HrWorkforceReadinessDashboard {
  owningCompanyId?: number;
  readyWorkers?: number;
  warningWorkers?: number;
  blockedWorkers?: number;
  overriddenWorkers?: number;
  rules?: number;
  activeOverrides?: number;
  driverQualifications?: number;
  qualifiedDrivers?: number;
  expiredDriverQualifications?: number;
  snapshots?: HrWorkforceReadinessSnapshot[];
  rulesList?: HrWorkforceReadinessRule[];
  overrides?: HrReadinessOverride[];
  qualifications?: HrDriverQualification[];
}

export const HR_READINESS_ASSIGNMENT_TYPES = ['GENERAL', 'SHIPMENT_DELIVERY', 'FLEET_MOBILIZATION', 'WAREHOUSE_SHIFT', 'CLEARANCE_ASSIGNMENT'];

export const HR_READINESS_STATUSES = ['READY', 'WARNING', 'BLOCKED', 'OVERRIDDEN', 'UNKNOWN'];

export const HR_READINESS_SEVERITIES = ['BLOCKER', 'WARN'];

export const HR_QUALIFICATION_STATUSES = ['QUALIFIED', 'PENDING', 'REJECTED', 'EXPIRED', 'WAIVED'];

